'use strict';

// This is the object returned by the `index.browseAll()` method
module.exports = IndexBrowser;
var inherits = require('inherits');
var EventEmitter = require('events').EventEmitter;
function IndexBrowser() {}
inherits(IndexBrowser, EventEmitter);
IndexBrowser.prototype.stop = function () {
  this._stopped = true;
  this._clean();
};
IndexBrowser.prototype._end = function () {
  this.emit('end');
  this._clean();
};
IndexBrowser.prototype._error = function (err) {
  this.emit('error', err);
  this._clean();
};
IndexBrowser.prototype._result = function (content) {
  this.emit('result', content);
};
IndexBrowser.prototype._clean = function () {
  this.removeAllListeners('stop');
  this.removeAllListeners('end');
  this.removeAllListeners('error');
  this.removeAllListeners('result');
};